export default {
  form: {
    header: {
      label: 'Overskrift',
      placeholder: 'Overskrift',
    },
    qr_code_header: {
      label: 'Overskrift til UI-boks',
      placeholder: 'Overskrift til UI-boks',
    },
    qr_code_description: {
      label: 'Beskrivelse til UI-boks',
      placeholder: 'Beskrivelse til UI-boks',
    },
    tag_text: {
      label: 'Tagtekst',
      placeholder: 'NYHED!',
    },
    footer: {
      label: 'Fodtekst',
      placeholder: 'Indtast fodtekst',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Vælg URL',
    },
    url: {
      placeholder: 'www.eksempel.dk',
    },
    primary_color: {
      label: 'Primær farve',
    },
    background_color: {
      label: 'Baggrundsfarve',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flyeren kunne ikke indlæses',
  },
};
